import { classAttr } from './utils';

/**
 * Bootstrap's className to fix body's scroll
 */
const FIX_CONTAINER_CLASS = 'modal-open';
/**
 * Stores an array of currently opened Modals
 * Notifies all modals when array is changed
 * Provides proper styling of a page's body (scroll fix)
 */
export class ModalsStack {
  private modals: string[] = [];
  private listeners: (() => void)[] = [];

  public stackChanged(comment: string) {
    this.listeners.forEach((func, ind) => {
      func();
    });
    this.fixBody(this.modals.length > 0);
  }

  public add(id: string, listener: () => void) {
    const ind = this.indexOf(id);
    if (ind === -1) {
      this.modals.push(id);

      // update subscribed modals before the new one is subscribed
      this.stackChanged('new');

      this.listeners.push(listener);
    }
  }

  public remove(id: string) {
    const ind = this.indexOf(id);
    if (ind > -1) {
      this.listeners.splice(ind, 1);
      this.modals.splice(ind, 1);

      this.stackChanged('remove');
    }
  }

  public isTop(id: string) {
    const res =
      this.modals.length > 0 && this.modals[this.modals.length - 1] === id;
    return res;
  }

  public getPosition(id: string) {
    const ind = this.indexOf(id);
    if (ind === -1) {
      return {
        bzIndex: 0,
        isTop: false,
        mzIndex: 0
      };
    }
    return {
      bzIndex: 1040 + ind * 10,
      isTop: this.isTop(id),
      mzIndex: 1050 + ind * 10
    };
  }

  private indexOf(id: string) {
    return this.modals.indexOf(id);
  }

  private fixBody(val: boolean) {
    if (val) {
      classAttr.add(document.body, FIX_CONTAINER_CLASS);
    } else {
      classAttr.remove(document.body, FIX_CONTAINER_CLASS);
    }
  }
}
